<template>
    <modal :modal-id="modalId"
                     :title="modalTitle"
                     :preloader="preloader"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `crud/${inputs.id}` : `crud`'>
                <div class="form-group row align-items-center">
                    <label for="inputs_name" class="col-sm-3 mb-0">
                        {{ $t('subject') }}
                    </label>
                    <app-input id="subject"
                        class="col-sm-9"
                        type="text"
                        v-model="inputs.subject"
                        :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_name" class="col-sm-3 mb-0">
                        {{ $t('description') }}
                    </label>
                    <app-input id="description"
                        class="col-sm-9"
                        type="textarea"
                        v-model="inputs.description"
                        :required="true"/>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin'
    import {ModalMixin} from "../../../../../app/Mixins/ModalMixin";
import { axiosPost } from '../../../../Helpers/AxiosHelper';
import { PACKAGE_STORE, PACKAGE_UPDATE, TICKET_STORE } from '../../../../Config/ApiUrl';

    export default {
        name: "AddModal",
        mixins: [FormMixin, ModalMixin],
        data() {
            return {
                preloader: false,
                inputs: {},
                duration: [
                    {id: '', value: "Choose One",},
                    {id: 'Day', value: "Day",},
                    {id: 'Week', value: "Weeks",},
                    {id: 'Month', value: "Month",},
                    {id: 'Year', value: "Year",},
                ],
                includes: [
                    {id: 'Emails', value: 'Emails'},
                    {id: 'Accounts', value: 'Accounts'},
                    {id: 'Notifications', value: 'Notifications'}
                ],
                modalId: 'demo-add-edit-Modal',
                modalTitle: this.$t('add'),
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            }
        },
        methods: {
            submit() {
                if (this.modalTitle == 'Edit') {
                    let split = this.selectedUrl.split('/');
                    this.inputs.task_id = split[6];
                    axiosPost(PACKAGE_UPDATE, this.inputs)
                        .then(res => {
                            
                        })
                        .catch (error => {
                            
                        });
                } else {
                    axiosPost(TICKET_STORE, this.inputs)
                    .then(res => {
                        
                    })
                    .catch(error => {
                        
                    });
                }
                // this.save(this.inputs);
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                if (response.data.phone) this.phone = response.data.phone;
                this.inputs = response.data;
                this.preloader = false;
            },
        },
    }
</script>
